<template>
  <div class="d-flex justify-center align-center position-fixed h-100 w-100">
    <v-progress-circular color="accent" indeterminate size="64" />
  </div>
</template>

<style scoped lang="scss"></style>
